import "./Dropdown.scss";
import upArrow from "../../assets/icons/upArrow.svg";
import { useState, useRef, useEffect, useCallback } from "react";

const Dropdown = ({
  setGenericState,
  genericState,
  labels,
  selectName,
  modifier,
}) => {
  const [open, setOpen] = useState(false);
  const dropRef = useRef("dropdown");

  const toggleDropdown = () => {
    setOpen(!open);
  };

  const closeOnOutsideClick = useCallback(
    (e) => {
      if (
        e.pointerType === "touch" ||
        e.pointerType === "mouse" ||
        e.pointerType === "pen"
      ) {
        if (dropRef.current && open && !dropRef.current.contains(e.target)) {
          setOpen(false);
        }
      }
    },
    [open]
  );

  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      setGenericState(e.target.innerText);
    }
  };

  useEffect(() => {
    document.addEventListener("pointerdown", closeOnOutsideClick);

    return () => {
      document.removeEventListener("pointerdown", closeOnOutsideClick);
    };
  }, [closeOnOutsideClick]);

  return (
    <button
      className={`dropdown`}
      type="button"
      ref={dropRef}
      onClick={toggleDropdown}
    >
      <div
        className={`dropdown__container ${
          open ? "dropdown__container--open" : ""
        } ${labels[0].includes("am") ? "dropdown__container--scroll" : ""} ${
          modifier ? "dropdown__container--large" : ""
        }`}
      >
        <p className={`dropdown__label`}>
          {genericState ? genericState : selectName}
        </p>
        <img
          src={upArrow}
          alt="arrow icon"
          className={`dropdown__arrow ${open ? "dropdown__arrow--open" : ""} ${
            labels[0].includes("am") ? "dropdown__arrow--scroll" : ""
          }`}
        />
      </div>
      <ul
        className={`dropdown-list ${
          labels[0].includes("am") ? "dropdown-list--scroll" : ""
        } ${open ? "" : "dropdown-list--closed"} ${
          modifier ? "dropdown-list--large" : ""
        }`}
      >
        {labels.map((label, i) => {
          return (
            <li
              className={`dropdown-list__item ${
                labels[0].includes("am") ? "dropdown-list__item--scroll" : ""
              } ${
                label === genericState ? "dropdown-list__item--selected" : ""
              }`}
              key={i}
              tabIndex={0}
              onKeyDown={onKeyDown}
              onClick={() => {
                setGenericState(label);
                setOpen(false);
              }}
            >
              {label}
            </li>
          );
        })}
      </ul>
    </button>
  );
};

export default Dropdown;
